import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {setShowJobPurchaseOrderPopup} from "../../../actions/A_Popups";
import {PURCHASE_ORDER_CONTENT} from "./jobPurchaseOrderReducer";
import JobPurchaseOrderPopupHeader from "./JobPurchaseOrderPopupHeader";
import JobPurchaseOrder from "./JobPurchaseOrderPopupContent/JobPurchaseOrder";
import JobPurchaseOrderPopupFooterButtons from "./JobPurchaseOrderPopupFooterButtons";
import MaterialsIcons from "../../Icons/MaterialsIcons";
import JobPurchaseOrderSuccess from "./JobPurchaseOrderPopupContent/JobPurchaseOrderSuccess";
import JobPurchaseOrderInvoice from "./JobPurchaseOrderPopupContent/JobPurchaseOrderInvoice";
import JobPurchaseOrderInvoiceSuccess from "./JobPurchaseOrderPopupContent/JobPurchaseOrderInvoiceSuccess";
import JobPurchaseOrderPay from "./JobPurchaseOrderPopupContent/JobPurchaseOrderPay";
import {getParsedJobOrder} from "./jobOrderFunctions";

const getPurchasePopupContent = (purchaseOrderStep) => {
  switch (purchaseOrderStep) {
    case PURCHASE_ORDER_CONTENT.purchaseOrder:
      return <JobPurchaseOrder/>
    case PURCHASE_ORDER_CONTENT.purchaseOrderSuccess:
    case PURCHASE_ORDER_CONTENT.purchaseOrderError:
      return <JobPurchaseOrderSuccess/>
    case PURCHASE_ORDER_CONTENT.purchaseOrderInvoice:
      return <JobPurchaseOrderInvoice/>
    case PURCHASE_ORDER_CONTENT.purchaseOrderInvoiceSuccess:
    case PURCHASE_ORDER_CONTENT.purchaseOrderInvoiceError:
      return <JobPurchaseOrderInvoiceSuccess/>
    case PURCHASE_ORDER_CONTENT.purchaseOrderPay:
    case PURCHASE_ORDER_CONTENT.purchaseOrderPaySuccess:
    case PURCHASE_ORDER_CONTENT.purchaseOrderPayError:
      return <JobPurchaseOrderPay/>
    default:
      return null;
  }
}

const JobPurchaseOrderPopup = (props) => {

  const {setShowJobPurchaseOrderPopup, purchaseOrderStep, job} = props;

  const closePopup = () => {
    setShowJobPurchaseOrderPopup(false);
  };

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  const invoicePages = purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoice
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoiceSuccess
    || purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderInvoiceError;

  return (
    <div className="ui-popup ui-popup--payment">
      <div className="job-payment flex">
        <div className="job-payment__left">
          <div className="job-payment__left-image"/>
          <div className="job-payment__box">
            <div className="job-payment__box-icon">
              {MaterialsIcons.CartFilledIcon}
            </div>
            <p className="job-payment__box-title">
              {invoicePages
                ? jobOrder && jobOrder.parentFabricatorName ? jobOrder.parentFabricatorName : null
                : <FormattedMessage id="paymentPopup.checkout"/>}
            </p>
            {invoicePages ? null : (
              <p className="job-payment__box-sub-title">
                <FormattedMessage id="paymentPopup.checkoutSubTitle"/>
              </p>
            )}
          </div>
        </div>
        <div className="job-payment__right">
          <JobPurchaseOrderPopupHeader closePopup={closePopup}/>
          {getPurchasePopupContent(purchaseOrderStep)}
          <JobPurchaseOrderPopupFooterButtons closePopup={closePopup}/>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {showJobPaymentPopup} = store.popups;
  const {purchaseOrderStep} = store.jobPurchaseOrderPopupState;
  const {job} = store.jobEditPopupState;

  return {
    showJobPaymentPopup,
    purchaseOrderStep,
    job,
  };
};

const mapDispatchToProps = {
  setShowJobPurchaseOrderPopup,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPurchaseOrderPopup)
)
